// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as DriverProofVMMapper from "./DriverProofVMMapper.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getView(partnerDocument) {
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: partnerDocument,
              children: (function (partnerDocument) {
                  return React.createElement(CardComponent$Catalyst.make, {
                              children: React.createElement(TableComponent$Catalyst.make, {
                                    columns: DriverProofVMMapper.getVM(undefined),
                                    rowData: partnerDocument,
                                    className: "order-table"
                                  })
                            });
                })
            });
}

export {
  getView ,
  
}
/* react Not a pure module */
